export const UPLOADCARE_TRANSFER_STARTED = 'zola/uploadcare/UPLOADCARE_TRANSFER_STARTED';
export const UPLOADCARE_TRANSFER_COMPLETE = 'zola/uploadcare/UPLOADCARE_TRANSFER_COMPLETE';
